import { ArboProperty, PropertyV2Search, PropertyV2Attribute } from "../types"

export function discoverPropertySearch(
  arbo: ArboProperty,
  id: number,
  title: string,
  reference: string,
  type: string,
  subtype: string,
  operation: string,
  price: number,
  tags: string,
  keywords: string,
  description: string,
  attributes: PropertyV2Attribute[]
): PropertyV2Search {
  
  const city = arbo.end_cidade && arbo.end_estado
    ? `${arbo.end_cidade} - ${arbo.end_estado}`
    : arbo.end_cidade || ""

  const bedrooms = arbo.qtd_quartos || 0
  const bathrooms = arbo.qtd_banheiro || 0
  const garage = arbo.qtd_vagas || 0
  const area = arbo.area_total || arbo.area_privativa || 0

  // Clean description for search
  const cleanDescription = description
    .toLowerCase()
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim()

  return {
    id,
    title,
    reference,
    type,
    subtype,
    operation,
    price,
    tags,
    keywords,
    description: cleanDescription,
    highlighted_date: null,
    state: arbo.end_estado || null,
    city,
    district: arbo.end_bairro || "",
    lat: arbo.latitude || 0,
    lon: arbo.longitude || 0,
    created_at: new Date().toISOString(),
    modified_at: null,
    updated_at: null,
    bed: bedrooms,
    bath: bathrooms,
    garage,
    area
  }
}